import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { empleadosApi } from '@/data/api/empleadosApi';
const KEY = 'empleados-admin';
export function useEmpleadosLista(filtros) {
    return useQuery({
        queryKey: [KEY, filtros],
        queryFn: () => empleadosApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function useEmpleado(id) {
    return useQuery({
        queryKey: [KEY, 'detalle', id],
        queryFn: () => empleadosApi.ver(id),
        enabled: Boolean(id),
    });
}
export function useHabilitacionesDe(id) {
    return useQuery({
        queryKey: [KEY, id, 'niveles'],
        queryFn: () => empleadosApi.listarHabilitaciones(id),
        enabled: Boolean(id),
    });
}
export function useCrearEmpleado() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => empleadosApi.crear(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useEditarEmpleado() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => empleadosApi.editar(id, values),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useDesactivarEmpleado() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => empleadosApi.desactivar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useHabilitar(empleadoId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => empleadosApi.habilitar(empleadoId, v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [KEY, empleadoId, 'niveles'] });
            qc.invalidateQueries({ queryKey: [KEY] });
        },
    });
}
export function useCerrarHabilitacion(empleadoId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ habilitacionId, hasta }) => empleadosApi.cerrarHabilitacion(empleadoId, habilitacionId, hasta),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, empleadoId, 'niveles'] }),
    });
}
export function useDisciplinas(opciones) {
    const activo = opciones?.activo;
    return useQuery({
        queryKey: ['catalogo', 'disciplinas', activo ?? 'activas'],
        queryFn: () => activo === undefined
            ? empleadosApi.disciplinas()
            : empleadosApi.listarDisciplinas(activo),
        staleTime: 10 * 60_000,
    });
}
export function useDisciplinasAdmin(filtroActivo) {
    return useQuery({
        queryKey: ['catalogo', 'disciplinas-admin', filtroActivo ?? 'todas'],
        queryFn: () => empleadosApi.listarDisciplinas(filtroActivo),
        staleTime: 60_000,
    });
}
export function useNivelesDeDisciplina(clave) {
    return useQuery({
        queryKey: ['catalogo', 'niveles', clave],
        queryFn: () => empleadosApi.nivelesDeDisciplina(clave),
        enabled: Boolean(clave),
        staleTime: 5 * 60_000,
    });
}
export function useCrearDisciplina() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ nombre, clave, orden }) => empleadosApi.crearDisciplina(nombre, clave, orden),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['catalogo', 'disciplinas'] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'disciplinas-admin'] });
        },
    });
}
export function useEditarDisciplina() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ clave, datos, }) => empleadosApi.editarDisciplina(clave, datos),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['catalogo', 'disciplinas'] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'disciplinas-admin'] });
        },
    });
}
export function useDesactivarDisciplina() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (clave) => empleadosApi.desactivarDisciplina(clave),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['catalogo', 'disciplinas'] });
            qc.invalidateQueries({ queryKey: ['catalogo', 'disciplinas-admin'] });
        },
    });
}
export function useCrearNivel() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ disciplinaClave, nombre, orden, }) => empleadosApi.crearNivel(disciplinaClave, nombre, orden),
        onSuccess: (_, v) => qc.invalidateQueries({ queryKey: ['catalogo', 'niveles', v.disciplinaClave] }),
    });
}
export function useDisponibilidadEmpleado(empleadoId, desde, hasta, excluirClaseId) {
    return useQuery({
        queryKey: ['empleados', empleadoId, 'disponibilidad', desde, hasta, excluirClaseId],
        queryFn: () => empleadosApi.disponibilidad(empleadoId, desde, hasta, excluirClaseId),
        enabled: Boolean(empleadoId && desde && hasta),
        staleTime: 15_000,
    });
}
